import { useState, useEffect, useRef } from "react";
import instance from "helpers/instance";
import jwt_decode from "jwt-decode";
import { setAuthPermission } from "helpers/checkForbidden";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authAtom } from "state/recoil-root";
import { registerSetAuth, registerGetAuth } from "helpers/recoilAuth";

function AuthInitializer({ children }) {
  const [initializing, setInitializing] = useState(true);
  const auth = useRecoilValue(authAtom);
  const setAuth = useSetRecoilState(authAtom);
  const authRef = useRef(auth);
  authRef.current = auth;

  registerSetAuth(setAuth);
  registerGetAuth(() => authRef.current);

  useEffect(() => {
    if (auth || window.location.hash.startsWith("#/auth")) {
      setInitializing(false);
      return;
    }
    instance({
      url: "usermanagement/v1/auth/refreshtoken",
      method: "POST",
      withCredentials: true,
      _skipAuthRefresh: true,
    })
      .then((res) => {
        const accessToken = res.data.data.access_token;
        const decoded = jwt_decode(accessToken);
        setAuthPermission(decoded.permission);
        setAuth({ ...decoded, access_token: accessToken });
      })
      .catch(() => {})
      .finally(() => {
        setInitializing(false);
      });
  }, []);

  if (initializing) {
    return null;
  }

  return children;
}

export { AuthInitializer };
